
import Vue from 'vue'

export default () => {
  const socket = Vue.notificationSocket
  if (socket) {
    socket.close()
  }
}


// WEBPACK FOOTER //
// ./src/services/notification/disconnectSocket.js